export class AssignDiscountTokenEntity {
    tokenValue;
    discountId;

    constructor(tokenValue, discountId) {
        this.tokenValue = tokenValue;
        this.discountId = discountId;
    }
}